import React from 'react';
import { ButtonProps } from 'antd';

import {
  StyledAntdButton,
} from './style';

const CVButton = (props: ButtonProps): JSX.Element => (
  <StyledAntdButton {...props} />
);

export default CVButton;
